import { RobotoTypography } from "@/shared/components/RobotoTypography";

import styles from "./UserMessage.module.css";

interface UserMessageProps {
  /**
   * Text content to display
   */
  text: string;
  isFailed?: boolean;
  onRetry?: () => void;
}

/**
 * Component for rendering user messages.
 * Displays plain text with appropriate styling for the variant.
 */
export function UserMessage({
  text,
  isFailed = false,
  onRetry,
}: UserMessageProps) {
  return (
    <div className={styles.indentedContainer}>
      <div
        className={`${styles.messageContainer} ${isFailed ? styles.failedMessageContainer : ""}`.trim()}
      >
        <RobotoTypography className={styles.text}>{text}</RobotoTypography>
        {isFailed && (
          <div className={styles.failedActions}>
            <RobotoTypography className={styles.failedText}>
              Failed to send
            </RobotoTypography>
            {onRetry && (
              <button
                type="button"
                className={styles.retryButton}
                onClick={onRetry}
              >
                Retry
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
